export const OUTBOUND_MESSAGE_STATUS_CHOICES = [
  { id: "PENDING", name: "Pending" },
  { id: "SENT", name: "Sent" },
  { id: "DELIVERED", name: "Delivered" },
  { id: "READ", name: "Read" },
  { id: "FAILED", name: "Failed" },
] as const;

export const OUTBOUND_MESSAGE_PURPOSE_CHOICES = [
  { id: "RAZA_EVENT_CONFIRMATION", name: "Raza event confirmation" },
  { id: "RAZA_EVENT_DAY_OF_REMINDER", name: "Raza event day-of reminder" },
  { id: "SADARAT_ALLOCATION_REMINDER", name: "Sadarat allocation reminder" },
  { id: "CONTRIBUTION_REMINDER", name: "Contribution reminder" },
  { id: "NIYAAZ_CONTRIBUTION_REMINDER", name: "Niyaaz contribution reminder" },
  { id: "HALL_ASSIGNMENT_SUMMARY", name: "Hall assignment summary" },
] as const;

export type OutboundMessageFilterChoice = { id: string; name: string };

/** Pure filter field configs for the outbound message list (no React elements). */
export function getOutboundMessageFilterFields(): Array<{
  source: string;
  label: string;
  kind: "select" | "text" | "date";
  choices?: readonly OutboundMessageFilterChoice[];
  alwaysOn?: boolean;
}> {
  return [
    {
      source: "status",
      label: "Status",
      kind: "select",
      choices: OUTBOUND_MESSAGE_STATUS_CHOICES,
    },
    {
      source: "purpose",
      label: "Purpose",
      kind: "select",
      choices: OUTBOUND_MESSAGE_PURPOSE_CHOICES,
    },
    { source: "templateName", label: "Template", kind: "text" },
    { source: "phone", label: "Phone", kind: "text", alwaysOn: true },
    { source: "startDate", label: "From", kind: "date" },
    { source: "endDate", label: "To", kind: "date" },
  ];
}
